import { NavigationData } from '../models/navigation.types';

export const navigationData: NavigationData = {
  mainMenu: [
    {
      id: 'products',
      title: 'Products',
      sections: [
        {
          title: 'Corporate Services',
          items: [
            {
              title: 'Legislation Monitor',
              route: '/legislation-monitor',
              icon: 'balance-scale',
              iconColor: '#4a6baf',
              description: 'Track and monitor legislative changes',
              pageTitle: 'Legislation Monitor - Track Legislative Changes',
              pageDescription: 'Real-time legislative tracking and alerts system for comprehensive monitoring of regulatory changes'
            },
            {
              title: 'Competitive/Edge',
              route: '/competitive-edge',
              icon: 'chart-line',
              iconColor: '#4a6baf',
              description: 'Real-time competitive market analysis',
              pageTitle: 'Competitive Edge - Market Analysis Tool',
              pageDescription: 'Advanced competitive analysis platform for real-time market intelligence and competitor tracking'
            },
            {
              title: 'Customer/Insight',
              route: '/customer-insight',
              icon: 'lightbulb',
              iconColor: '#4a6baf',
              description: 'Data-driven customer behavior analysis',
              pageTitle: 'Customer Insight - Behavior Analysis',
              pageDescription: 'Comprehensive customer behavior analysis tool for data-driven decision making'
            },
            {
              title: 'Supplier/IQ',
              route: '/supplier-iq',
              icon: 'industry',
              iconColor: '#4a6baf',
              description: 'Supply chain intelligence and analytics',
              pageTitle: 'Supplier IQ - Supply Chain Intelligence',
              pageDescription: 'Advanced supply chain analytics and intelligence platform for optimal supplier management'
            },
            {
              title: 'Daily Market Report',
              route: '/daily-market-report',
              icon: 'newspaper',
              iconColor: '#4a6baf',
              description: 'Daily market trends and analysis',
              pageTitle: 'Daily Market Report - Latest Trends',
              pageDescription: 'Daily insights and analysis of market trends, movements, and opportunities'
            }
          ]
        },
        {
          title: 'Subscription Services',
          items: [
            {
              title: 'Legislation Report',
              route: '/legislation-report',
              icon: 'gavel',
              iconColor: '#4a6baf',
              description: 'Comprehensive legislative analysis and reporting (Premium subscription)',
              isSubscription: true,
              isComplimentary: false,
              pageTitle: 'Legislation Report - Regulatory Analysis',
              pageDescription: 'In-depth analysis and reporting on legislative changes and regulatory developments'
            },
            {
              title: 'Sustainable Chemicals',
              route: '/sustainable-chemicals',
              icon: 'leaf',
              iconColor: '#4a6baf',
              description: 'Eco-friendly chemical industry insights (Premium subscription)',
              isSubscription: true,
              isComplimentary: false,
              pageTitle: 'Sustainable Chemicals - Industry Insights',
              pageDescription: 'In-depth analysis and insights into sustainable practices in the chemical industry'
            },
            {
              title: 'Executive Summary',
              route: '/executive-summary',
              icon: 'file-alt',
              iconColor: '#4a6baf',
              description: 'Key insights for strategic decisions (Complimentary subscription)',
              isSubscription: true,
              isComplimentary: true,
              pageTitle: 'Executive Summary - Strategic Insights',
              pageDescription: 'Comprehensive executive summaries providing key strategic insights for decision makers'
            }
          ]
        }
      ]
    },
    {
      id: 'solutions',
      title: 'Solutions',
      sections: [
        {
          title: 'By Function',
          items: [
            {
              title: 'Sales',
              route: '/departments/sales',
              icon: 'chart-line',
              iconColor: '#4a6baf',
              description: 'Sales optimization solutions for revenue growth and customer acquisition',
              pageTitle: 'Sales Department Solutions',
              pageDescription: 'Intelligence solutions for sales optimization and growth'
            },
            {
              title: 'Procurement',
              route: '/departments/procurement',
              icon: 'handshake',
              iconColor: '#4a6baf',
              description: 'Strategic procurement insights for supply chain optimization',
              pageTitle: 'Procurement Department Solutions',
              pageDescription: 'Strategic insights for procurement optimization'
            },
            {
              title: 'Compliance',
              route: '/departments/compliance',
              icon: 'clipboard-check',
              iconColor: '#4a6baf',
              description: 'Regulatory compliance tools for risk management and reporting',
              pageTitle: 'Compliance Department Solutions',
              pageDescription: 'Tools and insights for regulatory compliance management'
            },
            {
              title: 'Research',
              route: '/departments/research',
              icon: 'microscope',
              iconColor: '#4a6baf',
              description: 'Research and development solutions for innovation and market analysis',
              pageTitle: 'Research Department Solutions',
              pageDescription: 'Intelligence solutions for R&D optimization'
            },
            {
              title: 'Strategy',
              route: '/departments/strategy',
              icon: 'chess',
              iconColor: '#4a6baf',
              description: 'Strategic planning tools for long-term business growth and positioning',
              pageTitle: 'Strategy Department Solutions',
              pageDescription: 'Strategic planning and analysis tools for decision makers'
            }
          ]
        },
        {
          title: 'By Industry',
          items: [
            {
              title: 'Agriculture',
              route: '/industries/agriculture',
              icon: 'tractor',
              iconColor: '#4a6baf',
              description: 'Agricultural market insights',
              pageTitle: 'Agriculture Industry Solutions',
              pageDescription: 'Market intelligence solutions for the agriculture sector'
            },
            {
              title: 'Building Products',
              route: '/industries/building-products',
              icon: 'building',
              iconColor: '#4a6baf',
              description: 'Building products sector insights',
              pageTitle: 'Building Products Industry Solutions',
              pageDescription: 'Specialized intelligence solutions for the building products industry'
            },
            {
              title: 'Chemicals',
              route: '/industries/chemicals',
              icon: 'flask',
              iconColor: '#4a6baf',
              description: 'Chemical industry analysis',
              pageTitle: 'Chemical Industry Solutions',
              pageDescription: 'Comprehensive analysis and insights for the chemical industry'
            },
            {
              title: 'Food & Beverage',
              route: '/industries/food-and-beverage',
              icon: 'utensils',
              iconColor: '#4a6baf',
              description: 'Food and beverage insights',
              pageTitle: 'Food & Beverage Industry Solutions',
              pageDescription: 'Strategic solutions for the food and beverage industry'
            },
            {
              title: 'Forestry & Timberland',
              route: '/industries/forestry-and-timberland',
              icon: 'tree',
              iconColor: '#4a6baf',
              description: 'Forestry sector intelligence',
              pageTitle: 'Forestry & Timberland Industry Solutions',
              pageDescription: 'Strategic insights for forestry and timberland management'
            },
            {
              title: 'Healthcare',
              route: '/industries/healthcare',
              icon: 'hospital',
              iconColor: '#4a6baf',
              description: 'Healthcare sector analysis',
              pageTitle: 'Healthcare Industry Solutions',
              pageDescription: 'Comprehensive insights for the healthcare industry'
            },
            {
              title: 'Household Products',
              route: '/industries/household-products',
              icon: 'home',
              iconColor: '#4a6baf',
              description: 'Household products insights',
              pageTitle: 'Household Products Industry Solutions',
              pageDescription: 'Market intelligence for the household products sector'
            },
            {
              title: 'Metals',
              route: '/industries/metals',
              icon: 'cog',
              iconColor: '#4a6baf',
              description: 'Metals industry insights',
              pageTitle: 'Metals Industry Solutions',
              pageDescription: 'Market intelligence solutions for the metals sector'
            },
            {
              title: 'Packaging',
              route: '/industries/packaging',
              icon: 'box',
              iconColor: '#4a6baf',
              description: 'Packaging sector intelligence',
              pageTitle: 'Packaging Industry Solutions',
              pageDescription: 'Strategic insights for the packaging industry'
            },
            {
              title: 'Personal Care',
              route: '/industries/personal-care',
              icon: 'pump-soap',
              iconColor: '#4a6baf',
              description: 'Personal care industry analysis',
              pageTitle: 'Personal Care Industry Solutions',
              pageDescription: 'Strategic insights for the personal care industry'
            },
            {
              title: 'Printing',
              route: '/industries/printing',
              icon: 'print',
              iconColor: '#4a6baf',
              description: 'Printing industry analysis',
              pageTitle: 'Printing Industry Solutions',
              pageDescription: 'Comprehensive solutions for the printing sector'
            },
            {
              title: 'Pulp & Paper',
              route: '/industries/pulp-and-paper',
              icon: 'scroll',
              iconColor: '#4a6baf',
              description: 'Pulp and paper sector insights',
              pageTitle: 'Pulp & Paper Industry Solutions',
              pageDescription: 'Intelligence solutions for the pulp and paper industry'
            },
            {
              title: 'Retail',
              route: '/industries/retail',
              icon: 'shopping-cart',
              iconColor: '#4a6baf',
              description: 'Retail sector analysis',
              pageTitle: 'Retail Industry Solutions',
              pageDescription: 'Strategic analysis for the retail sector'
            },
            {
              title: 'Tissue & Hygiene',
              route: '/industries/tissue-and-hygiene',
              icon: 'toilet-paper',
              iconColor: '#4a6baf',
              description: 'Tissue and hygiene insights',
              pageTitle: 'Tissue & Hygiene Industry Solutions',
              pageDescription: 'Market intelligence for the tissue and hygiene industry'
            }
          ]
        }
      ]
    },
    {
      id: 'resources',
      title: 'Resources',
      sections: [
        {
          title: 'Content',
          items: [
            {
              title: 'Blog',
              route: '/blog',
              icon: 'rss',
              iconColor: '#4a6baf',
              description: 'Industry insights and analysis',
              pageTitle: 'Industry Intelligence Blog',
              pageDescription: 'Latest insights, analysis, and thought leadership on industry trends'
            },
            {
              title: 'Webinars',
              route: '/webinars',
              icon: 'video',
              iconColor: '#4a6baf',
              description: 'Expert-led online sessions',
              pageTitle: 'Industry Intelligence Webinars',
              pageDescription: 'Expert-led webinars on industry trends, challenges, and opportunities'
            },
            {
              title: 'White Papers',
              route: '/white-papers',
              icon: 'file-pdf',
              iconColor: '#4a6baf',
              description: 'In-depth research and analysis',
              pageTitle: 'Industry Intelligence White Papers',
              pageDescription: 'In-depth research and analysis on industry-specific topics'
            },
            {
              title: 'Case Studies',
              route: '/case-studies',
              icon: 'briefcase',
              iconColor: '#4a6baf',
              description: 'Real-world success stories',
              pageTitle: 'Industry Intelligence Case Studies',
              pageDescription: 'Real-world success stories and implementation examples'
            }
          ]
        },
        {
          title: 'Support',
          items: [
            {
              title: 'Help Center',
              route: '/help',
              icon: 'question-circle',
              iconColor: '#4a6baf',
              description: 'Guides and documentation',
              pageTitle: 'Industry Intelligence Help Center',
              pageDescription: 'Comprehensive guides and documentation for all our products and services'
            },
            {
              title: 'Contact Support',
              route: '/contact',
              icon: 'headset',
              iconColor: '#4a6baf',
              description: 'Get assistance from our team',
              pageTitle: 'Contact Industry Intelligence Support',
              pageDescription: 'Get assistance from our dedicated support team'
            },
            {
              title: 'Training',
              route: '/training',
              icon: 'graduation-cap',
              iconColor: '#4a6baf',
              description: 'Product training and certification',
              pageTitle: 'Industry Intelligence Training',
              pageDescription: 'Product training and certification programs for optimal usage'
            },
            {
              title: 'API Documentation',
              route: '/api-docs',
              icon: 'code',
              iconColor: '#4a6baf',
              description: 'Developer resources and guides',
              pageTitle: 'Industry Intelligence API Documentation',
              pageDescription: 'Comprehensive API documentation and developer resources'
            }
          ]
        }
      ]
    }
  ],
  footerSections: [
    {
      title: 'Products',
      links: [
        {
          title: 'Legislation Monitor',
          route: '/legislation-monitor'
        },
        {
          title: 'Competitive/Edge',
          route: '/competitive-edge'
        },
        {
          title: 'Customer/Insight',
          route: '/customer-insight'
        },
        {
          title: 'Supplier/IQ',
          route: '/supplier-iq'
        },
        {
          title: 'Daily Market Report',
          route: '/daily-market-report'
        },
        {
          title: 'Executive Summary',
          route: '/executive-summary'
        },
        {
          title: 'Sustainable Chemicals',
          route: '/sustainable-chemicals'
        }
      ]
    },
    {
      title: 'Solutions by Industry',
      links: [
        {
          title: 'Agriculture',
          route: '/industries/agriculture'
        },
        {
          title: 'Building Products',
          route: '/industries/building-products'
        },
        {
          title: 'Chemicals',
          route: '/industries/chemicals'
        },
        {
          title: 'Food & Beverage',
          route: '/industries/food-and-beverage'
        },
        {
          title: 'Forestry & Timberland',
          route: '/industries/forestry-and-timberland'
        },
        {
          title: 'Healthcare',
          route: '/industries/healthcare'
        },
        {
          title: 'Household Products',
          route: '/industries/household-products'
        },
        {
          title: 'Metals',
          route: '/industries/metals'
        },
        {
          title: 'Packaging',
          route: '/industries/packaging'
        },
        {
          title: 'Personal Care',
          route: '/industries/personal-care'
        },
        {
          title: 'Printing',
          route: '/industries/printing'
        },
        {
          title: 'Pulp & Paper',
          route: '/industries/pulp-and-paper'
        },
        {
          title: 'Retail',
          route: '/industries/retail'
        },
        {
          title: 'Tissue & Hygiene',
          route: '/industries/tissue-and-hygiene'
        }
      ]
    },
    {
      title: 'Solutions by Function',
      links: [
        {
          title: 'Sales',
          route: '/departments/sales'
        },
        {
          title: 'Procurement',
          route: '/departments/procurement'
        },
        {
          title: 'Compliance',
          route: '/departments/compliance'
        },
        {
          title: 'Research',
          route: '/departments/research'
        },
        {
          title: 'Strategy',
          route: '/departments/strategy'
        }
      ]
    },
    {
      title: 'Resources',
      links: [
        {
          title: 'Blog',
          route: '/blog'
        },
        {
          title: 'Webinars',
          route: '/webinars'
        },
        {
          title: 'White Papers',
          route: '/white-papers'
        },
        {
          title: 'Case Studies',
          route: '/case-studies'
        },
        {
          title: 'Help Center',
          route: '/help'
        },
        {
          title: 'Contact Support',
          route: '/contact'
        },
        {
          title: 'Training',
          route: '/training'
        },
        {
          title: 'API Documentation',
          route: '/api-docs'
        }
      ]
    },
    {
      title: 'Company',
      links: [
        {
          title: 'About Us',
          route: '/about'
        },
        {
          title: 'Careers',
          route: '/careers'
        },
        {
          title: 'Social Responsibility',
          route: '/social-responsibility'
        },
        {
          title: 'Contact',
          route: '/contact'
        },
        {
          title: 'Brand Guidelines',
          route: '/brand-guidelines'
        }
      ]
    }
  ],
  socialLinks: [
    {
      icon: 'twitter',
      url: 'https://twitter.com/IndustryIntel',
      label: 'X (Twitter)'
    },
    {
      icon: 'linkedin',
      url: 'https://linkedin.com/company/industry-intelligence',
      label: 'LinkedIn'
    },
    {
      icon: 'youtube',
      url: 'https://youtube.com/IndustryIntelligence',
      label: 'YouTube'
    }
  ],
  legalLinks: [
    {
      title: 'Privacy Policy',
      route: '/privacy-policy'
    },
    {
      title: 'Terms of Use',
      route: '/terms'
    },
    {
      title: 'Service Agreement',
      route: '/service-agreement'
    },
    {
      title: 'Do Not Sell or Share My Information',
      route: '/privacy-choices'
    }
  ],
  additionalRoutes: [
    {
      title: 'Brand Guidelines',
      route: '/brand-guidelines',
      pageTitle: 'Brand Guidelines',
      pageDescription: 'Official brand guidelines and resources for Industry Intelligence'
    },
    {
      title: 'About Us',
      route: '/about',
      pageTitle: 'About Industry Intelligence',
      pageDescription: 'Learn about our mission, vision, and commitment to industry intelligence'
    },
    {
      title: 'Careers',
      route: '/careers',
      pageTitle: 'Careers at Industry Intelligence',
      pageDescription: 'Join our team and help shape the future of industry intelligence'
    },
    {
      title: 'Contact',
      route: '/contact',
      pageTitle: 'Contact Us',
      pageDescription: 'Get in touch with our team for support or inquiries'
    }
  ]
};